import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Header", function(app) {
  app.view("Index", {
    events: {
      "click #nav_item_create_js": "_onAddAdvertiserCampaignClick"
    },

    initialize: function(args) {
      app.Views.Index.__super__.initialize.apply(this, arguments);
      if (app.config.allowedToUseKeyboardShortcuts) {
        this._initKeyboardShortcuts();
      }
    },

    _initKeyboardShortcuts: function() {
      var modal = this.child("keyboardShortcuts");
      modal && modal.close();
      this.child("keyboardShortcuts", new app.Views.KeyboardShortcutsIndex());
    },

    _onAddAdvertiserCampaignClick: function(event) {
      var modal = this.child("advertiserCampaignModal");
      modal && modal.close();
      modal = new app.Views.NewAdvertiserCampaignModal();
      this.child("advertiserCampaignModal", modal).render();
    }
  });
});
